
import { AcceptedApplicantsComponent } from './accepted-applicants/accepted-applicants.component';
import { AcceptedApplicantsService } from './accepted-applicants/accepted-applicants.service';
import { AddReviewerComponent } from './add-reviewer/add-reviewer.component';
import { AllApplicantsComponent } from './applicants/applicants.component';
import { AllApplicantsService } from './applicants/applicants.service';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ApplicantComponent } from './applicant/applicant.component';
import { ApplicantsService } from './applicant/applicant.service';
import { AssignReviewerComponent } from './assign-reviewer/assign-reviewer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CertificationService } from './applicant/certification.service';
import { CommentsComponent } from './comments/comments.component';
import { CommentsService } from './comments/comments.service';
import { CommonService } from './common/common.services';
import { ComposeEmailComponent } from './compose-email/compose-email.component';
import { ContactInfoService } from './applicant/contact-information.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardService } from './dashboard/dashboard.service';
import { EducationalBackgroundService } from './applicant/educational-background.service';
import { EmailComponent } from './email/email.component';
import { ExaminationService } from './applicant/examinations-taken.service';
import { ExaminationSubjectService } from './applicant/examination-subject.service';
import { FinanceStudyService } from './applicant/finance-study.service';
import { FooterComponent } from './footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptorService } from './common/httpinterceptor.service';
import { LayoutModule } from '@angular/cdk/layout';
import { LeftNavbarComponent } from './left-navbar/left-navbar.component';
import { LocationStrategy, HashLocationStrategy, CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { LoginGuardService } from './common/loginguard.service';
import { LoginService } from './login/login.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NavbarComponent } from './navbar/navbar.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { PersonService } from './applicant/person.service';
import { PortfolioService } from './applicant/portfolio-review.service';
import { PreUniversityService } from './applicant/previous.university.service';
import { ProgrammeSelectionService } from './accepted-applicants/programme-selection.service';
import { ReadEmailComponent } from './read-email/read-email.component';
import { ReportService } from './reports/reports.service';
import { ReportsComponent } from './reports/reports.component';
import { SignUpService } from './sign-ups/sign-ups.service';
import { SignUpsComponent } from './sign-ups/sign-ups.component';
import { StudentIdComponent } from './student-id/student-id.component';
import { UrlSignature } from './common/apiEndpoint';
import { RegisteredApplicantsComponent } from './registered-applicants/registered-applicants.component';
import { RegisteredApplicantsService } from './registered-applicants/registered-applicants.service';
import { NgxLoadingModule } from 'ngx-loading';
import { ToastrModule } from 'ngx-toastr';
import { CtvetatendanceComponent } from './ctvetatendance/ctvetatendance.component';
import { CtvetdashboardComponent } from './ctvetdashboard/ctvetdashboard.component';
import { RegisterctvetstudentComponent } from './registerctvetstudent/registerctvetstudent.component';
import { WebcamModule } from 'ngx-webcam';
import { CtvetattendancerollcallComponent } from './ctvetattendancerollcall/ctvetattendancerollcall.component';
import { CtvetfacialsComponent } from './ctvetfacials/ctvetfacials.component';
import { SuperloginComponent } from './superlogin/superlogin.component';
import { AdmindashboardComponent } from './dashboard/admindashboard/admindashboard.component';
import { RegistrardashboardComponent } from './dashboard/registrardashboard/registrardashboard.component';
import { QadashboardComponent } from './dashboard/qadashboard/qadashboard.component';
import { LecturerdashboardComponent } from './dashboard/lecturerdashboard/lecturerdashboard.component';
import { HoddashboardComponent } from './dashboard/hoddashboard/hoddashboard.component';
import { ManagementdashboardComponent } from './dashboard/managementdashboard/managementdashboard.component';
import { SuperadminDashboardComponent } from './dashboard/superadmin-dashboard/superadmin-dashboard.component';
import { RolemanagementComponent } from './dashboard/superadmin-dashboard/superadminpages/rolemanagement/rolemanagement.component';
import { UseraccountsComponent } from './dashboard/superadmin-dashboard/superadminpages/useraccounts/useraccounts.component';
import { NewsignupsComponent } from './newsignups/newsignups.component';
import { NewsignupsmonthlygraphComponent } from './newsignupsmonthlygraph/newsignupsmonthlygraph.component';
import { ApplicationreviewComponent } from './applicationreview/applicationreview.component';
import { SemapplicantsComponent } from './semapplicants/semapplicants.component';
import { FinancedashboardComponent } from './financedashboard/financedashboard.component';
import { ApplicationfeesdashboardComponent } from './applicationfeesdashboard/applicationfeesdashboard.component';
import { AddfeesitemsComponent } from './addfeesitems/addfeesitems.component';
import { RetreivefeeitemsComponent } from './retreivefeeitems/retreivefeeitems.component';
import { ApplicantfromoldappComponent } from './applicantfromoldapp/applicantfromoldapp.component';



@NgModule({
  declarations: [
    AppComponent,
    AcceptedApplicantsComponent,
    AddReviewerComponent,
    AllApplicantsComponent,
    ApplicantComponent,
    AssignReviewerComponent,
    CommentsComponent,
    ComposeEmailComponent,
    DashboardComponent,
    EmailComponent,
    FooterComponent,
    LeftNavbarComponent,
    LoginComponent,
    NavbarComponent,
    ReadEmailComponent,
    ReportsComponent,
    SignUpsComponent,
    StudentIdComponent,
    RegisteredApplicantsComponent,
    CtvetatendanceComponent,
    CtvetdashboardComponent,
    RegisterctvetstudentComponent,
    CtvetattendancerollcallComponent,
    CtvetfacialsComponent,
    AdmindashboardComponent,
    RegistrardashboardComponent,
    QadashboardComponent,
    LecturerdashboardComponent,
    HoddashboardComponent,
    ManagementdashboardComponent,
    SuperadminDashboardComponent,
    RolemanagementComponent,
    UseraccountsComponent,
    NewsignupsComponent,
    NewsignupsmonthlygraphComponent,
    ApplicationreviewComponent,
    SemapplicantsComponent,
    FinancedashboardComponent,
    ApplicationfeesdashboardComponent,
    AddfeesitemsComponent,
    RetreivefeeitemsComponent,
    ApplicantfromoldappComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    LayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    NgxLoadingModule.forRoot({}),
    ToastrModule.forRoot(),
    WebcamModule,
    CommonModule,
    SuperloginComponent


  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    MatDatepickerModule,
    LoginService,
    UrlSignature,
    AllApplicantsService,
    ApplicantsService,
    CommonService,
    ProgrammeSelectionService,
    AcceptedApplicantsService,
    DashboardService,
    LoginGuardService,
    ContactInfoService,
    CertificationService,
    FinanceStudyService,
    PortfolioService,
    ExaminationService,
    PersonService,
    EducationalBackgroundService,
    ExaminationSubjectService,
    PreUniversityService,
    ReportService,
    SignUpService,
    CommentsService,
    RegisteredApplicantsService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
